import Box from "@mui/material/Box";
import { useLocation, useParams } from "react-router-dom";
import queryString from "query-string";
import { Config } from "../Config";
import { App } from "../services/Types";
import {v4 as uuidv4} from 'uuid';
import {deflateRaw} from 'pako';

function AppPage() {
  const params: { app: string } = useParams();
  const { search } = useLocation();

  const app = Config.apps.find((app: App) => app.id === params.app);
  if (app) {
    let redirectUrl;
    // classic url with OBOM Token
    if(app.id === 'classic' && app.relayState && search.includes('OBOMTOKEN'))
    {
      redirectUrl = generateClassicUrlWithRelayState(app, search);
    }
    else
    {
      redirectUrl = app.salesforceRedirect || app.url;
      if (redirectUrl.includes("?")) {
        redirectUrl += search.replace("?", "&");
      } else {
        redirectUrl += search;
      }
    }
    console.info("App URL:", app.url);
    console.info("Redirecting to:", redirectUrl);
    window.location.href = redirectUrl;
    return <></>;
  } else {
    return <Box>Application not found.</Box>;
  }
}

function generateClassicUrlWithRelayState(app: App, search: string)
{
  //Generate SAML request
  const id = `id${uuidv4()}`;
  const issueInstant = new Date().toISOString();
  const issuer = app.relayState?.issuer;
  const assertionConsumerServiceURL = app.relayState?.assertionConsumerServiceURL;
  const msaldomain = Config.msal.domain;

  const samlRequest =  `<samlp:AuthnRequest xmlns="urn:oasis:names:tc:SAML:2.0:metadata" ID="${id}" Version="2.0" IssueInstant="${issueInstant}" IsPassive="false" AssertionConsumerServiceURL="${assertionConsumerServiceURL}"
  xmlns:samlp="urn:oasis:names:tc:SAML:2.0:protocol" ForceAuthn="false"><Issuer xmlns="urn:oasis:names:tc:SAML:2.0:assertion">${issuer}</Issuer></samlp:AuthnRequest>`;

  const samlRequestCompressed = deflateRaw(samlRequest);
  var samlRequestBase64Encoded = btoa(samlRequestCompressed.reduce((acc, current) => acc + String.fromCharCode(current), ""));
  const samlRequestEncoded = encodeURIComponent(`${samlRequestBase64Encoded}`);

  //Convert returnUrl to RelayState by encoding the OBOMTOKEN value and the URL
  const queryValues = queryString.parse(search);
  let returnUrl = queryValues.returnUrl;
  let returnUrlValue = returnUrl?.toString();
  if (returnUrl && returnUrl?.indexOf("OBOMTOKEN") > 0) {
    const regex = new RegExp(/(OBOMTOKEN=)[^\&]+/);
    const OBOMTOKEN = regex.exec(returnUrl?.toString());
    if(OBOMTOKEN && OBOMTOKEN?.length >= 1) {
      returnUrlValue = returnUrlValue?.replace(/(OBOMTOKEN=)[^\&]+/, "$1" + encodeURIComponent(OBOMTOKEN[0].replace("OBOMTOKEN=", "")));
    }
  }

  var relayStateEncoded = encodeURIComponent(`${returnUrlValue}`)

  //Generate URL
  const redirectUrl = `${msaldomain}/saml2?SAMLRequest=${samlRequestEncoded}&RelayState=${relayStateEncoded}`;

  return redirectUrl;
}

export default AppPage;
